import _ from "lodash";
import store from "services/redux/store";
import { addDataByGuid } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchTimeslotGroups from 'utils/fetch/FetchTimeslotGroups'

export default class FetchCachedTimeslotGroups
{
	static logName = 'FetchCachedTimeslotGroups';
	static values = null;
	static cacheUpdatedAt = null;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'timeslotGroups',
				tables: [ 'timeslot_groups' ],
				onExpire: this.reload,
				updated_at_max_age: ( 5 * 60 ) // updated_at needs to be refresh at most each 5 minutes for this table
			}, this.process )
		);
	};

	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
				onFresh: () => {
					if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
						callbackSuccess( this.values )
					}
				},
				onExpired: () => {
					this.reload( {callbackSuccess, callbackError, callbackStart} )
				}
		})
			);
		});
	}

	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchTimeslotGroups.fetchAll({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( timeslotGroups ) => {
						// Save to object
						this.process( timeslotGroups );


						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, timeslotGroups, true );

						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess( timeslotGroups );
						}
					}
				})
			);
		}
		);
	}

	static process = ( timeslotGroups ) => {
		this.values = timeslotGroups;
		store.dispatch( addDataByGuid( dataConstants.TIMESLOT_GROUPS, this.values ) );
	}
}
